import { useEffect, useRef } from 'react';

export default function PhilosophyChapter02() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .scale-in').forEach((el) => el.classList.add('visible'));
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="chapter2" className="py-20 px-6 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12 fade-up">
          <p className="text-lg font-bold mb-4" style={{ color: '#3E5F8F' }}>02</p>
          <h2 className="text-3xl md:text-4xl font-normal text-gray-900 mb-6" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            《あなた専用 矯正プラン比較レポート》
          </h2>
          <p className="text-base text-gray-700 leading-relaxed">
            マウスピース矯正を検討される方の多くが抱える「迷い」。<br />
            その正体は、情報が足りないからではなく、<br />
            「判断軸」が整理されていないことにあります。<br /><br />
            実際、情報を集めれば集めるほど、<br />
            かえって判断が難しくなってしまう方も少なくありません。
          </p>
        </div>

        <div className="mb-12 scale-in">
          <img
            alt="判断整理レポート"
            className="w-full rounded-lg"
            src="https://storage.googleapis.com/studio-design-asset-files/projects/Kwa5AGrYaX/s-1649x1878_v-frms_webp_bfc64f58-af11-440b-b5a7-e0dc193232f2_small.webp"
          />
        </div>

        <div className="mb-12 fade-up">
          <p className="text-base text-gray-700 leading-relaxed mb-6">
            そこで当院では、<br />
            20項目以上の専門的な診査結果をもとに、<br />
            あなた専用の《判断整理レポート》を作成し、<br />
            無料で提供しています。<br />
            このレポートによって、次の「判断軸」を得られます。
          </p>
          <div className="bg-white rounded-lg p-6 mb-6">
            <p className="text-sm text-gray-800 leading-relaxed">
              ・何を考える必要があるのか<br />
              ・どこが判断の分かれ目になるのか<br />
              ・今は決めなくてもいい点はどこか
            </p>
          </div>
          <p className="text-base text-gray-700 leading-relaxed">
            これらを一目でわかるように整理し、<br />
            あなたが「後悔しない判断ができる状態」をつくる。<br />
            それが、このレポートを提供する私たちの唯一の目的です。
          </p>
        </div>

        <div className="mb-12 scale-in">
          <img
            alt="レポートイメージ"
            className="w-full rounded-lg"
            src="https://storage.googleapis.com/studio-design-asset-files/projects/Kwa5AGrYaX/s-1456x816_v-fms_webp_4166d93f-5b8d-41f7-b926-19370ef552a2_small.webp"
          />
        </div>

        <div className="rounded-lg p-8 fade-up" style={{ backgroundColor: '#EEF3F9' }}>
          <p className="text-sm text-gray-700 leading-relaxed">情報の多さは、必ずしも納得には繋がりません。</p>
          <p className="text-base text-gray-800 font-medium mt-4">
            複雑な情報を、あなたが選べる形にまで整えること。<br />
            それが歯科医師としての私たちの「役割」だと考えています。<br />
            次の章では、マウスピース矯正の物理的な限界についてお話しします。
          </p>
        </div>
      </div>
    </section>
  );
}